export default class Isotr112282 {
    switch1=false
    switch2=false
    switch3=false
    switch4=false
    switch5=false
    switch6=false    
    informacionLaboral=[
        {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
        {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
        {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
        {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
        {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
        {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
        ]    
}


// WEBPACK FOOTER //
// ./src/model/Isotr11228-2.js